import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { API_URL } from '../config';
import PhotoCarousel from '../components/PhotoCarousel';

import './HomePage.css';

function HomePage() {
const navigate = useNavigate();

const [themes, setThemes] = useState([]);

useEffect(() => {
  fetch(`${API_URL}/themes`)
    .then(res => res.json())
    .then(data => setThemes(data))
    .catch(err => console.error("Erreur fetch thèmes :", err));
}, []);

  return (
    <div className="home-page">
      <header
        className="hero"
        style={{ backgroundImage: `url("${process.env.PUBLIC_URL}/monailz_logo.png")` }}
      >
        <button className="btn-grad" onClick={() => navigate('/reservation')}>Réserver maintenant</button>
      </header>

      <section className="prestations">
        <h3 className='Description'>J'AIME LE CHROME, LES STRASS, LE STILETTO, BIEN AIGUISE, LES POSES COLOREES ET PRENDRE LE TEMPS QU'IL FAUT</h3>
        <div className="socials">
        <a
          className="socialBtn Insta"
          href="https://www.instagram.com/monailz.fr/"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram de Monailz"
        >
            <span className="svgContainer">
                <svg fill="white" className="svgIcon" viewBox="0 0 448 512" height="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>
            </span>
            <span className="BG"></span>
        </a>
        <a
          className="socialBtn TikTok"
          href="https://www.tiktok.com/@monailz.fr"
          target="_blank"
          rel="noreferrer"
          aria-label="TikTok de Monailz"
        >
  <span className="svgContainer">
    <svg
      className="svgIcon"
      viewBox="0 0 48 48"
      height="1.5em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.0766847,15.8542954 C36.0693906,15.7935177 34.2504839,14.8341149 32.8791434,13.5466056 
           C32.1316475,12.8317108 31.540171,11.9694126 31.1415066,11.0151329 
           C30.7426093,10.0603874 30.5453728,9.03391952 30.5619062,8 
           L24.9731521,8 L24.9731521,28.8295196 
           C24.9731521,32.3434487 22.8773693,34.4182737 20.2765028,34.4182737 
           C19.6505623,34.4320127 19.0283477,34.3209362 18.4461858,34.0908659 
           C17.8640239,33.8612612 17.3337909,33.5175528 16.8862248,33.0797671 
           C16.4386588,32.6422142 16.0833071,32.1196657 15.8404292,31.5426268 
           C15.5977841,30.9658208 15.4727358,30.3459348 15.4727358,29.7202272 
           C15.4727358,29.0940539 15.5977841,28.4746337 15.8404292,27.8978277 
           C16.0833071,27.3207888 16.4386588,26.7980074 16.8862248,26.3604545 
           C17.3337909,25.9229017 17.8640239,25.5791933 18.4461858,25.3491229 
           C19.0283477,25.1192854 19.6505623,25.0084418 20.2765028,25.0219479 
           C20.7939283,25.0263724 21.3069293,25.1167239 21.794781,25.2902081 
           L21.794781,19.5985278 C21.2957518,19.4900128 20.7869423,19.436221 20.2765028,19.4380839 
           C18.2431278,19.4392483 16.2560928,20.0426009 14.5659604,21.1729264 
           C12.875828,22.303019 11.5587449,23.9090873 10.7814424,25.7878401 
           C10.003907,27.666593 9.80084889,29.7339663 10.1981162,31.7275214 
           C10.5953834,33.7217752 11.5748126,35.5530237 13.0129853,36.9904978 
           C14.4509252,38.4277391 16.2828722,39.4064696 18.277126,39.8028054 
           C20.2711469,40.1991413 22.3382874,39.9951517 24.2163416,39.2169177 
           C26.0948616,38.4384508 27.7002312,37.1209021 28.8296253,35.4300711 
           C29.9592522,33.7397058 30.5619062,31.7522051 30.5619062,29.7188301 
           L30.5619062,18.8324027 C32.7275484,20.3418321 35.3149087,21.0404263 38.0766847,21.0867664 
           L38.0766847,15.8542954 Z"
        fill="white"
      ></path>
    </svg>
  </span>
  <span className="BG"></span>
</a>

</div>
        <h2 className='Collec' id="collections">Collections</h2>
        <div className="cards">
          {themes.map(theme => (
            <div className="card" key={theme.id}>
              <PhotoCarousel
                photos={theme.photoFilenames.map(f => `${API_URL}/uploads/${f}`)}
                alt={theme.titre}
              />
              <h3>{theme.titre}</h3>
              {theme.description && <p>{theme.description}</p>}
            </div>
          ))}
        </div>
      </section>

      <footer className="footer">
        <p>© 2026 Monailz' -  Lille</p>
      </footer>
    </div>
  );
}

export default HomePage;
